import React from 'react'
import { View } from 'react-native'

import { Dialog } from '../../Dialog'
import { useDemandeAbsenceStyles } from '../../../modules/DemandeAbsence/DemandeAbsence.styles'

import ChampModal from '../../ChampModal/ChampModal.component'
import { Absence } from '../../../api/Absence/types'
import { AffichagePeriode } from '../../AffichagePeriode/AffichagePeriode'

interface DetailAbsenceProps {
  onClose: () => void
  selectedAbsence: Absence | null
}

const DetailAbsence = ({ onClose, selectedAbsence }: DetailAbsenceProps) => {

  const { styles } = useDemandeAbsenceStyles();

  if(selectedAbsence){
    const heures = Math.floor(selectedAbsence.totalHeures)
    const minutes = Math.round((selectedAbsence.totalHeures - heures) * 100)
    const heureFormattee = `${heures}h${minutes > 0 ? minutes : '00'}`
    return (
      <Dialog
        visible={true}
        onClose={onClose}
        title="Détails de l'absence"
      >
        <View style={styles.containerPart}>
          <ChampModal title='Type :' content={selectedAbsence.natureAbsence?.libelle || selectedAbsence.natureAbsence?.code} />
          <ChampModal title='Période :' content={
            <AffichagePeriode
              dateDebut={selectedAbsence.dateDebut}
              dateFin={selectedAbsence.dateFin}
              heureDebut={selectedAbsence.heureDebut}
              heureFin={selectedAbsence.heureFin}
              direction='column'/>}
            />
          <ChampModal title='Durée:' content={`${selectedAbsence.totalJours}J soit ${heureFormattee}`} />
        </View>
      </Dialog>
    )
  }
}

export default DetailAbsence;
